import defaultConfig from '@/config/partnerConfigs'
import getPartnerConfigBySlug from '@/server/utils/getPartnerConfigBySlug'
import { getPartnerSlug } from '@/utils'

const getPartnerConfig = () => {
  const partnerSlug = getPartnerSlug()

  if (partnerSlug) {
    const partnerConfig = getPartnerConfigBySlug(partnerSlug)

    // If there's no config for the partner redirect to the root
    if (!partnerConfig) {
      if (window.location.pathname !== '/') {
        window.location.pathname = '/'
      }

      // Returning the default config as fallback
      return defaultConfig
    }

    return partnerConfig
  }

  return undefined
}

export default getPartnerConfig
